@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(-662_619_893)
public val Res.string.hiring_status_draft: StringResource by lazy {
      StringResource("string:hiring_status_draft", "hiring_status_draft", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 149991, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 211847, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 136194, 35),
      ))
    }

@delegate:ResourceContentHash(-544_887_869)
public val Res.string.hiring_status_open: StringResource by lazy {
      StringResource("string:hiring_status_open", "hiring_status_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 150039, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 211899, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 136230, 34),
      ))
    }

@delegate:ResourceContentHash(1_179_730_184)
public val Res.string.hiring_title: StringResource by lazy {
      StringResource("string:hiring_title", "hiring_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 150082, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 211950, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 136265, 28),
      ))
    }

@delegate:ResourceContentHash(-1_815_296_225)
public val Res.string.hiring_unread_count: StringResource by lazy {
      StringResource("string:hiring_unread_count", "hiring_unread_count", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 150119, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 212011, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 136294, 43),
      ))
    }

@delegate:ResourceContentHash(-728_906_920)
public val Res.string.incoming_sales_all_months: StringResource by lazy {
      StringResource("string:incoming_sales_all_months", "incoming_sales_all_months", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 150175, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 212079, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 136338, 65),
      ))
    }

@delegate:ResourceContentHash(-809_964_435)
public val Res.string.incoming_sales_month: StringResource by lazy {
      StringResource("string:incoming_sales_month", "incoming_sales_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 150245, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 212157, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 136404, 36),
      ))
    }

@delegate:ResourceContentHash(-2_090_145_731)
public val Res.string.incoming_sales_no_access: StringResource by lazy {
      StringResource("string:incoming_sales_no_access", "incoming_sales_no_access", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 150286, 220),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 212202, 320),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 136441, 172),
      ))
    }

@delegate:ResourceContentHash(1_656_150_659)
public val Res.string.incoming_sales_preview: StringResource by lazy {
      StringResource("string:incoming_sales_preview", "incoming_sales_preview", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 150507, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 212523, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 136614, 46),
      ))
    }

@delegate:ResourceContentHash(41_569_120)
public val Res.string.incoming_sales_text: StringResource by lazy {
      StringResource("string:incoming_sales_text", "incoming_sales_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 150558, 147),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 212626, 255),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 136661, 143),
      ))
    }

@delegate:ResourceContentHash(-120_446_625)
public val Res.string.incoming_sales_title: StringResource by lazy {
      StringResource("string:incoming_sales_title", "incoming_sales_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 150706, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 212882, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 136805, 60),
      ))
    }

@delegate:ResourceContentHash(-368_813_086)
public val Res.string.interview_cancel: StringResource by lazy {
      StringResource("string:interview_cancel", "interview_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 151028, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 213360, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 137127, 52),
      ))
    }

@delegate:ResourceContentHash(-1_855_631_242)
public val Res.string.interview_cancel_confirm_text: StringResource by lazy {
      StringResource("string:interview_cancel_confirm_text", "interview_cancel_confirm_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 150771, 133),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 212971, 209),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 136866, 133),
      ))
    }

@delegate:ResourceContentHash(-1_093_092_337)
public val Res.string.interview_cancel_confirm_title: StringResource by lazy {
      StringResource("string:interview_cancel_confirm_title", "interview_cancel_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 150905, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 213181, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 137000, 70),
      ))
    }

@delegate:ResourceContentHash(-727_994_271)
public val Res.string.interview_cancelled: StringResource by lazy {
      StringResource("string:interview_cancelled", "interview_cancelled", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 150976, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 213280, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 137071, 55),
      ))
    }

@delegate:ResourceContentHash(1_173_124_640)
public val Res.string.interview_candidate: StringResource by lazy {
      StringResource("string:interview_candidate", "interview_candidate", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 151145, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 213533, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 137252, 47),
      ))
    }

@delegate:ResourceContentHash(1_410_423_715)
public val Res.string.interview_candidate_removed: StringResource by lazy {
      StringResource("string:interview_candidate_removed", "interview_candidate_removed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 151077, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 213437, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 137180, 71),
      ))
    }

@delegate:ResourceContentHash(742_298_918)
public val Res.string.interview_clash: StringResource by lazy {
      StringResource("string:interview_clash", "interview_clash", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 151193, 99),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 213593, 143),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 137300, 107),
      ))
    }

@delegate:ResourceContentHash(1_087_886_853)
public val Res.string.interview_date: StringResource by lazy {
      StringResource("string:interview_date", "interview_date", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 151293, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 213737, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 137408, 26),
      ))
    }

@delegate:ResourceContentHash(1_090_076_939)
public val Res.string.interview_dialog_title: StringResource by lazy {
      StringResource("string:interview_dialog_title", "interview_dialog_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 151324, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 213772, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 137435, 50),
      ))
    }

@delegate:ResourceContentHash(344_263_477)
public val Res.string.interview_error_length: StringResource by lazy {
      StringResource("string:interview_error_length", "interview_error_length", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 151375, 86),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 213839, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 137486, 86),
      ))
    }

@delegate:ResourceContentHash(-875_100_926)
public val Res.string.interview_error_link: StringResource by lazy {
      StringResource("string:interview_error_link", "interview_error_link", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 151462, 96),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 213970, 128),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 137573, 88),
      ))
    }

@delegate:ResourceContentHash(1_708_938_243)
public val Res.string.interview_error_participants: StringResource by lazy {
      StringResource("string:interview_error_participants", "interview_error_participants", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 151559, 96),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 214099, 144),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 137662, 72),
      ))
    }

@delegate:ResourceContentHash(-649_315_105)
public val Res.string.interview_error_place: StringResource by lazy {
      StringResource("string:interview_error_place", "interview_error_place", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 151656, 89),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 214244, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 137735, 73),
      ))
    }

@delegate:ResourceContentHash(-2_002_239_102)
public val Res.string.interview_error_time: StringResource by lazy {
      StringResource("string:interview_error_time", "interview_error_time", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 151746, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 214382, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 137809, 68),
      ))
    }

@delegate:ResourceContentHash(908_774_921)
public val Res.string.interview_length: StringResource by lazy {
      StringResource("string:interview_length", "interview_length", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 151823, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 214471, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 137878, 32),
      ))
    }

@delegate:ResourceContentHash(-1_869_448_476)
public val Res.string.interview_move: StringResource by lazy {
      StringResource("string:interview_move", "interview_move", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 152018, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 214746, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138045, 30),
      ))
    }

@delegate:ResourceContentHash(609_044_729)
public val Res.string.interview_moved: StringResource by lazy {
      StringResource("string:interview_moved", "interview_moved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 151922, 95),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 214602, 143),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 137961, 83),
      ))
    }

@delegate:ResourceContentHash(1_756_783_253)
public val Res.string.interview_moved_quiet: StringResource by lazy {
      StringResource("string:interview_moved_quiet", "interview_moved_quiet", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 151864, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 214524, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 137911, 49),
      ))
    }

@delegate:ResourceContentHash(-294_614_051)
public val Res.string.interview_no_email: StringResource by lazy {
      StringResource("string:interview_no_email", "interview_no_email", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 152061, 110),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 214797, 166),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138076, 102),
      ))
    }

@delegate:ResourceContentHash(-1_614_321_666)
public val Res.string.interview_note: StringResource by lazy {
      StringResource("string:interview_note", "interview_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 152172, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 214964, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138179, 54),
      ))
    }

@delegate:ResourceContentHash(605_102_779)
public val Res.string.interview_online_link: StringResource by lazy {
      StringResource("string:interview_online_link", "interview_online_link", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 152223, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 215043, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138234, 57),
      ))
    }

@delegate:ResourceContentHash(389_401_298)
public val Res.string.interview_paid: StringResource by lazy {
      StringResource("string:interview_paid", "interview_paid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 152422, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 215350, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138425, 34),
      ))
    }

@delegate:ResourceContentHash(457_972_162)
public val Res.string.interview_paid_hint: StringResource by lazy {
      StringResource("string:interview_paid_hint", "interview_paid_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 152285, 95),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 215141, 151),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138292, 95),
      ))
    }

@delegate:ResourceContentHash(729_506_708)
public val Res.string.interview_paid_label: StringResource by lazy {
      StringResource("string:interview_paid_label", "interview_paid_label", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 152381, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 215293, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138388, 36),
      ))
    }

@delegate:ResourceContentHash(562_059_309)
public val Res.string.interview_participants: StringResource by lazy {
      StringResource("string:interview_participants", "interview_participants", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 152461, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 215413, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138460, 50),
      ))
    }

@delegate:ResourceContentHash(1_159_043_964)
public val Res.string.interview_place: StringResource by lazy {
      StringResource("string:interview_place", "interview_place", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 152593, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 215593, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138572, 31),
      ))
    }

@delegate:ResourceContentHash(-1_307_290_958)
public val Res.string.interview_place_hint: StringResource by lazy {
      StringResource("string:interview_place_hint", "interview_place_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 152516, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 215484, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138511, 60),
      ))
    }

@delegate:ResourceContentHash(905_869_685)
public val Res.string.interview_reschedule_title: StringResource by lazy {
      StringResource("string:interview_reschedule_title", "interview_reschedule_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 152629, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 215633, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138604, 58),
      ))
    }

@delegate:ResourceContentHash(857_918_362)
public val Res.string.interview_save: StringResource by lazy {
      StringResource("string:interview_save", "interview_save", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 152744, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 215800, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138715, 34),
      ))
    }

@delegate:ResourceContentHash(1_940_465_208)
public val Res.string.interview_save_move: StringResource by lazy {
      StringResource("string:interview_save_move", "interview_save_move", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 152692, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 215724, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138663, 51),
      ))
    }

@delegate:ResourceContentHash(-502_856_941)
public val Res.string.interview_schedule: StringResource by lazy {
      StringResource("string:interview_schedule", "interview_schedule", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 152913, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 216081, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138888, 54),
      ))
    }

@delegate:ResourceContentHash(273_394_801)
public val Res.string.interview_scheduled: StringResource by lazy {
      StringResource("string:interview_scheduled", "interview_scheduled", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 152833, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 215941, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138812, 75),
      ))
    }

@delegate:ResourceContentHash(1_369_684_399)
public val Res.string.interview_scheduled_quiet: StringResource by lazy {
      StringResource("string:interview_scheduled_quiet", "interview_scheduled_quiet", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 152775, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 215851, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138750, 61),
      ))
    }

@delegate:ResourceContentHash(1_623_698_111)
public val Res.string.interview_send: StringResource by lazy {
      StringResource("string:interview_send", "interview_send", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 152960, 94),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 216164, 154),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138943, 90),
      ))
    }

@delegate:ResourceContentHash(54_664_342)
public val Res.string.interview_status_cancelled: StringResource by lazy {
      StringResource("string:interview_status_cancelled", "interview_status_cancelled", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 153055, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 216319, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 139034, 46),
      ))
    }

@delegate:ResourceContentHash(1_877_157_926)
public val Res.string.interview_time: StringResource by lazy {
      StringResource("string:interview_time", "interview_time", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 153154, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 216442, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 139133, 38),
      ))
    }

@delegate:ResourceContentHash(-324_524_482)
public val Res.string.interview_time_hint: StringResource by lazy {
      StringResource("string:interview_time_hint", "interview_time_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 153102, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 216378, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 139081, 51),
      ))
    }

@delegate:ResourceContentHash(452_145_461)
public val Res.string.interview_title: StringResource by lazy {
      StringResource("string:interview_title", "interview_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 153205, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 216493, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 139172, 43),
      ))
    }

@delegate:ResourceContentHash(786_283_086)
public val Res.string.interview_unpaid_hint: StringResource by lazy {
      StringResource("string:interview_unpaid_hint", "interview_unpaid_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 153261, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 216545, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 139216, 69),
      ))
    }

@delegate:ResourceContentHash(-118_655_490)
public val Res.string.interview_unpaid_label: StringResource by lazy {
      StringResource("string:interview_unpaid_label", "interview_unpaid_label", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 153343, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 216667, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 139286, 38),
      ))
    }

@delegate:ResourceContentHash(-987_479_231)
public val Res.string.interview_when: StringResource by lazy {
      StringResource("string:interview_when", "interview_when", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 153390, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 216730, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 139325, 46),
      ))
    }

@delegate:ResourceContentHash(-1_727_032_812)
public val Res.string.interview_with: StringResource by lazy {
      StringResource("string:interview_with", "interview_with", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 153437, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 216777, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 139372, 50),
      ))
    }

@delegate:ResourceContentHash(-1_709_951_317)
public val Res.string.interviews_section: StringResource by lazy {
      StringResource("string:interviews_section", "interviews_section", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 153480, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 216840, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 139423, 42),
      ))
    }

@delegate:ResourceContentHash(172_614_927)
public val Res.string.invite_copied: StringResource by lazy {
      StringResource("string:invite_copied", "invite_copied", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 153519, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 216895, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 139466, 29),
      ))
    }

@delegate:ResourceContentHash(-1_901_030_709)
public val Res.string.invite_copy: StringResource by lazy {
      StringResource("string:invite_copy", "invite_copy", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 153557, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 216949, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 139496, 43),
      ))
    }

@delegate:ResourceContentHash(1_835_869_519)
public val Res.string.invite_ready_body: StringResource by lazy {
      StringResource("string:invite_ready_body", "invite_ready_body", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 153601, 185),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 217033, 329),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 139540, 189),
      ))
    }

@delegate:ResourceContentHash(865_039_361)
public val Res.string.invite_ready_title: StringResource by lazy {
      StringResource("string:invite_ready_title", "invite_ready_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 153787, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 217363, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 139730, 50),
      ))
    }

@delegate:ResourceContentHash(-691_612_992)
public val Res.string.invite_share_text: StringResource by lazy {
      StringResource("string:invite_share_text", "invite_share_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 153838, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 217434, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 139781, 73),
      ))
    }

@delegate:ResourceContentHash(-388_707_876)
public val Res.string.issue_basis_company: StringResource by lazy {
      StringResource("string:issue_basis_company", "issue_basis_company", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 154058, 107),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 217806, 183),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140001, 119),
      ))
    }

@delegate:ResourceContentHash(-1_622_477_869)
public val Res.string.issue_basis_company_elsewhere: StringResource by lazy {
      StringResource("string:issue_basis_company_elsewhere", "issue_basis_company_elsewhere", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 153916, 141),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 217532, 273),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 139855, 145),
      ))
    }

@delegate:ResourceContentHash(-989_552_666)
public val Res.string.issue_basis_labour_code: StringResource by lazy {
      StringResource("string:issue_basis_labour_code", "issue_basis_labour_code", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 154166, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 217990, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140121, 67),
      ))
    }

@delegate:ResourceContentHash(-1_235_327_393)
public val Res.string.issue_dated: StringResource by lazy {
      StringResource("string:issue_dated", "issue_dated", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 154234, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 218078, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140189, 35),
      ))
    }

@delegate:ResourceContentHash(-1_353_761_326)
public val Res.string.issue_double_shift: StringResource by lazy {
      StringResource("string:issue_double_shift", "issue_double_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 154270, 142),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 218114, 162),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140225, 114),
      ))
    }

@delegate:ResourceContentHash(-101_742_611)
public val Res.string.issue_elsewhere_overlap_at: StringResource by lazy {
      StringResource("string:issue_elsewhere_overlap_at", "issue_elsewhere_overlap_at", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 154413, 118),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 218277, 166),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140340, 90),
      ))
    }

@delegate:ResourceContentHash(1_275_105_607)
public val Res.string.issue_elsewhere_overlap_other: StringResource by lazy {
      StringResource("string:issue_elsewhere_overlap_other", "issue_elsewhere_overlap_other", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 154532, 129),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 218444, 189),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140431, 109),
      ))
    }

@delegate:ResourceContentHash(1_463_223_819)
public val Res.string.issue_elsewhere_rest_at: StringResource by lazy {
      StringResource("string:issue_elsewhere_rest_at", "issue_elsewhere_rest_at", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 154662, 151),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 218634, 215),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140541, 143),
      ))
    }

@delegate:ResourceContentHash(-1_354_484_149)
public val Res.string.issue_elsewhere_rest_other: StringResource by lazy {
      StringResource("string:issue_elsewhere_rest_other", "issue_elsewhere_rest_other", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 154814, 162),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 218850, 238),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140685, 162),
      ))
    }

@delegate:ResourceContentHash(-879_638_299)
public val Res.string.issue_forced_absence: StringResource by lazy {
      StringResource("string:issue_forced_absence", "issue_forced_absence", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 154977, 140),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 219089, 196),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140848, 96),
      ))
    }

@delegate:ResourceContentHash(1_998_813_470)
public val Res.string.issue_forced_elsewhere: StringResource by lazy {
      StringResource("string:issue_forced_elsewhere", "issue_forced_elsewhere", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 155118, 122),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 219286, 174),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140945, 102),
      ))
    }

@delegate:ResourceContentHash(-1_065_406_782)
public val Res.string.issue_forced_rest: StringResource by lazy {
      StringResource("string:issue_forced_rest", "issue_forced_rest", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 155241, 137),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 219461, 181),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141048, 105),
      ))
    }

@delegate:ResourceContentHash(-908_213_654)
public val Res.string.issue_group_absence: StringResource by lazy {
      StringResource("string:issue_group_absence", "issue_group_absence", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 155379, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 219643, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141154, 39),
      ))
    }

@delegate:ResourceContentHash(-749_063_526)
public val Res.string.issue_group_availability: StringResource by lazy {
      StringResource("string:issue_group_availability", "issue_group_availability", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 155427, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 219703, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141194, 48),
      ))
    }

@delegate:ResourceContentHash(-1_918_312_960)
public val Res.string.issue_group_double_booking: StringResource by lazy {
      StringResource("string:issue_group_double_booking", "issue_group_double_booking", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 155484, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 219768, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141243, 54),
      ))
    }

@delegate:ResourceContentHash(1_936_051_198)
public val Res.string.issue_group_rest: StringResource by lazy {
      StringResource("string:issue_group_rest", "issue_group_rest", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 155551, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 219855, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141298, 32),
      ))
    }

@delegate:ResourceContentHash(-1_638_200_818)
public val Res.string.issue_group_shift_lead: StringResource by lazy {
      StringResource("string:issue_group_shift_lead", "issue_group_shift_lead", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 155592, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 219908, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141331, 66),
      ))
    }

@delegate:ResourceContentHash(-783_708_009)
public val Res.string.issue_group_staff_checks: StringResource by lazy {
      StringResource("string:issue_group_staff_checks", "issue_group_staff_checks", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 155659, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 219995, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141398, 76),
      ))
    }

@delegate:ResourceContentHash(991_306_835)
public val Res.string.issue_group_working_hours: StringResource by lazy {
      StringResource("string:issue_group_working_hours", "issue_group_working_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 155736, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 220104, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141475, 53),
      ))
    }

@delegate:ResourceContentHash(898_164_771)
public val Res.string.issue_mark_conflict: StringResource by lazy {
      StringResource("string:issue_mark_conflict", "issue_mark_conflict", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 155786, 215),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 220166, 363),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141529, 183),
      ))
    }

@delegate:ResourceContentHash(-1_425_934_787)
public val Res.string.issue_mark_gavel: StringResource by lazy {
      StringResource("string:issue_mark_gavel", "issue_mark_gavel", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 156002, 136),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 220530, 228),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141713, 104),
      ))
    }

@delegate:ResourceContentHash(-2_083_501_515)
public val Res.string.issue_mark_health: StringResource by lazy {
      StringResource("string:issue_mark_health", "issue_mark_health", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 156139, 109),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 220759, 173),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141818, 93),
      ))
    }

@delegate:ResourceContentHash(-1_798_168_278)
public val Res.string.issue_mark_lead: StringResource by lazy {
      StringResource("string:issue_mark_lead", "issue_mark_lead", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 156249, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 220933, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141912, 55),
      ))
    }

@delegate:ResourceContentHash(1_640_391_159)
public val Res.string.issue_mark_supervised: StringResource by lazy {
      StringResource("string:issue_mark_supervised", "issue_mark_supervised", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 156325, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 221045, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141968, 73),
      ))
    }

@delegate:ResourceContentHash(-10_082_594)
public val Res.string.issue_marks_title: StringResource by lazy {
      StringResource("string:issue_marks_title", "issue_marks_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 156399, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 221163, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142042, 53),
      ))
    }

@delegate:ResourceContentHash(-1_879_763_287)
public val Res.string.issue_open_shift: StringResource by lazy {
      StringResource("string:issue_open_shift", "issue_open_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 156457, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 221245, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142096, 44),
      ))
    }

@delegate:ResourceContentHash(113_069_688)
public val Res.string.issue_overlap: StringResource by lazy {
      StringResource("string:issue_overlap", "issue_overlap", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 156502, 93),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 221306, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142141, 89),
      ))
    }

@delegate:ResourceContentHash(1_807_230_587)
public val Res.string.issue_person_marks: StringResource by lazy {
      StringResource("string:issue_person_marks", "issue_person_marks", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 156596, 106),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 221440, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142231, 86),
      ))
    }

@delegate:ResourceContentHash(-895_888_530)
public val Res.string.issue_person_none: StringResource by lazy {
      StringResource("string:issue_person_none", "issue_person_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 156703, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 221571, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142318, 57),
      ))
    }

@delegate:ResourceContentHash(957_363_095)
public val Res.string.issue_person_title: StringResource by lazy {
      StringResource("string:issue_person_title", "issue_person_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 156773, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 221677, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142376, 46),
      ))
    }

@delegate:ResourceContentHash(-1_929_570_855)
public val Res.string.issue_shift_marks: StringResource by lazy {
      StringResource("string:issue_shift_marks", "issue_shift_marks", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 156828, 85),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 221744, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142423, 77),
      ))
    }

@delegate:ResourceContentHash(1_263_668_583)
public val Res.string.issue_shift_title: StringResource by lazy {
      StringResource("string:issue_shift_title", "issue_shift_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 156914, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 221866, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142501, 61),
      ))
    }

@delegate:ResourceContentHash(2_085_471_230)
public val Res.string.issue_short_break: StringResource by lazy {
      StringResource("string:issue_short_break", "issue_short_break", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 156972, 165),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 221932, 257),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142563, 157),
      ))
    }

@delegate:ResourceContentHash(710_998_407)
public val Res.string.issue_staff_checks: StringResource by lazy {
      StringResource("string:issue_staff_checks", "issue_staff_checks", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 157138, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 222190, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142721, 58),
      ))
    }

@delegate:ResourceContentHash(818_499_077)
public val Res.string.issue_unavailable: StringResource by lazy {
      StringResource("string:issue_unavailable", "issue_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 157201, 97),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 222273, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142780, 81),
      ))
    }

@delegate:ResourceContentHash(1_633_027_330)
public val Res.string.job_close: StringResource by lazy {
      StringResource("string:job_close", "job_close", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 157350, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 222482, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142901, 37),
      ))
    }

@delegate:ResourceContentHash(-364_638_576)
public val Res.string.job_closed: StringResource by lazy {
      StringResource("string:job_closed", "job_closed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 157299, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 222419, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142862, 38),
      ))
    }

@delegate:ResourceContentHash(-418_705_554)
public val Res.string.job_contract_b2b: StringResource by lazy {
      StringResource("string:job_contract_b2b", "job_contract_b2b", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 157396, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 222544, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142939, 40),
      ))
    }

@delegate:ResourceContentHash(1_300_185_249)
public val Res.string.job_contract_employment: StringResource by lazy {
      StringResource("string:job_contract_employment", "job_contract_employment", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 157437, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 222593, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142980, 59),
      ))
    }

@delegate:ResourceContentHash(254_074_109)
public val Res.string.job_contract_mandate: StringResource by lazy {
      StringResource("string:job_contract_mandate", "job_contract_mandate", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 157489, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 222689, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143040, 56),
      ))
    }

@delegate:ResourceContentHash(1_634_830_993)
public val Res.string.job_contract_other: StringResource by lazy {
      StringResource("string:job_contract_other", "job_contract_other", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 157538, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 222786, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143097, 34),
      ))
    }

@delegate:ResourceContentHash(-1_291_581_869)
public val Res.string.job_cv_hint: StringResource by lazy {
      StringResource("string:job_cv_hint", "job_cv_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 157597, 139),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 222825, 235),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143132, 143),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString18Resources(map: MutableMap<String, StringResource>) {
  map.put("hiring_status_draft", Res.string.hiring_status_draft)
  map.put("hiring_status_open", Res.string.hiring_status_open)
  map.put("hiring_title", Res.string.hiring_title)
  map.put("hiring_unread_count", Res.string.hiring_unread_count)
  map.put("incoming_sales_all_months", Res.string.incoming_sales_all_months)
  map.put("incoming_sales_month", Res.string.incoming_sales_month)
  map.put("incoming_sales_no_access", Res.string.incoming_sales_no_access)
  map.put("incoming_sales_preview", Res.string.incoming_sales_preview)
  map.put("incoming_sales_text", Res.string.incoming_sales_text)
  map.put("incoming_sales_title", Res.string.incoming_sales_title)
  map.put("interview_cancel", Res.string.interview_cancel)
  map.put("interview_cancel_confirm_text", Res.string.interview_cancel_confirm_text)
  map.put("interview_cancel_confirm_title", Res.string.interview_cancel_confirm_title)
  map.put("interview_cancelled", Res.string.interview_cancelled)
  map.put("interview_candidate", Res.string.interview_candidate)
  map.put("interview_candidate_removed", Res.string.interview_candidate_removed)
  map.put("interview_clash", Res.string.interview_clash)
  map.put("interview_date", Res.string.interview_date)
  map.put("interview_dialog_title", Res.string.interview_dialog_title)
  map.put("interview_error_length", Res.string.interview_error_length)
  map.put("interview_error_link", Res.string.interview_error_link)
  map.put("interview_error_participants", Res.string.interview_error_participants)
  map.put("interview_error_place", Res.string.interview_error_place)
  map.put("interview_error_time", Res.string.interview_error_time)
  map.put("interview_length", Res.string.interview_length)
  map.put("interview_move", Res.string.interview_move)
  map.put("interview_moved", Res.string.interview_moved)
  map.put("interview_moved_quiet", Res.string.interview_moved_quiet)
  map.put("interview_no_email", Res.string.interview_no_email)
  map.put("interview_note", Res.string.interview_note)
  map.put("interview_online_link", Res.string.interview_online_link)
  map.put("interview_paid", Res.string.interview_paid)
  map.put("interview_paid_hint", Res.string.interview_paid_hint)
  map.put("interview_paid_label", Res.string.interview_paid_label)
  map.put("interview_participants", Res.string.interview_participants)
  map.put("interview_place", Res.string.interview_place)
  map.put("interview_place_hint", Res.string.interview_place_hint)
  map.put("interview_reschedule_title", Res.string.interview_reschedule_title)
  map.put("interview_save", Res.string.interview_save)
  map.put("interview_save_move", Res.string.interview_save_move)
  map.put("interview_schedule", Res.string.interview_schedule)
  map.put("interview_scheduled", Res.string.interview_scheduled)
  map.put("interview_scheduled_quiet", Res.string.interview_scheduled_quiet)
  map.put("interview_send", Res.string.interview_send)
  map.put("interview_status_cancelled", Res.string.interview_status_cancelled)
  map.put("interview_time", Res.string.interview_time)
  map.put("interview_time_hint", Res.string.interview_time_hint)
  map.put("interview_title", Res.string.interview_title)
  map.put("interview_unpaid_hint", Res.string.interview_unpaid_hint)
  map.put("interview_unpaid_label", Res.string.interview_unpaid_label)
  map.put("interview_when", Res.string.interview_when)
  map.put("interview_with", Res.string.interview_with)
  map.put("interviews_section", Res.string.interviews_section)
  map.put("invite_copied", Res.string.invite_copied)
  map.put("invite_copy", Res.string.invite_copy)
  map.put("invite_ready_body", Res.string.invite_ready_body)
  map.put("invite_ready_title", Res.string.invite_ready_title)
  map.put("invite_share_text", Res.string.invite_share_text)
  map.put("issue_basis_company", Res.string.issue_basis_company)
  map.put("issue_basis_company_elsewhere", Res.string.issue_basis_company_elsewhere)
  map.put("issue_basis_labour_code", Res.string.issue_basis_labour_code)
  map.put("issue_dated", Res.string.issue_dated)
  map.put("issue_double_shift", Res.string.issue_double_shift)
  map.put("issue_elsewhere_overlap_at", Res.string.issue_elsewhere_overlap_at)
  map.put("issue_elsewhere_overlap_other", Res.string.issue_elsewhere_overlap_other)
  map.put("issue_elsewhere_rest_at", Res.string.issue_elsewhere_rest_at)
  map.put("issue_elsewhere_rest_other", Res.string.issue_elsewhere_rest_other)
  map.put("issue_forced_absence", Res.string.issue_forced_absence)
  map.put("issue_forced_elsewhere", Res.string.issue_forced_elsewhere)
  map.put("issue_forced_rest", Res.string.issue_forced_rest)
  map.put("issue_group_absence", Res.string.issue_group_absence)
  map.put("issue_group_availability", Res.string.issue_group_availability)
  map.put("issue_group_double_booking", Res.string.issue_group_double_booking)
  map.put("issue_group_rest", Res.string.issue_group_rest)
  map.put("issue_group_shift_lead", Res.string.issue_group_shift_lead)
  map.put("issue_group_staff_checks", Res.string.issue_group_staff_checks)
  map.put("issue_group_working_hours", Res.string.issue_group_working_hours)
  map.put("issue_mark_conflict", Res.string.issue_mark_conflict)
  map.put("issue_mark_gavel", Res.string.issue_mark_gavel)
  map.put("issue_mark_health", Res.string.issue_mark_health)
  map.put("issue_mark_lead", Res.string.issue_mark_lead)
  map.put("issue_mark_supervised", Res.string.issue_mark_supervised)
  map.put("issue_marks_title", Res.string.issue_marks_title)
  map.put("issue_open_shift", Res.string.issue_open_shift)
  map.put("issue_overlap", Res.string.issue_overlap)
  map.put("issue_person_marks", Res.string.issue_person_marks)
  map.put("issue_person_none", Res.string.issue_person_none)
  map.put("issue_person_title", Res.string.issue_person_title)
  map.put("issue_shift_marks", Res.string.issue_shift_marks)
  map.put("issue_shift_title", Res.string.issue_shift_title)
  map.put("issue_short_break", Res.string.issue_short_break)
  map.put("issue_staff_checks", Res.string.issue_staff_checks)
  map.put("issue_unavailable", Res.string.issue_unavailable)
  map.put("job_close", Res.string.job_close)
  map.put("job_closed", Res.string.job_closed)
  map.put("job_contract_b2b", Res.string.job_contract_b2b)
  map.put("job_contract_employment", Res.string.job_contract_employment)
  map.put("job_contract_mandate", Res.string.job_contract_mandate)
  map.put("job_contract_other", Res.string.job_contract_other)
  map.put("job_cv_hint", Res.string.job_cv_hint)
}
